import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Sun, Moon } from "lucide-react";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem("theme") === "dark");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", darkMode);
    localStorage.setItem("theme", darkMode ? "dark" : "light");
  }, [darkMode]);



const navLinks = [
//Example
//<Link to="/">Home</Link>
//<Link to="/courses">Courses</Link>
//<Link to="/books">Books</Link>
//<Link to="/vidoes">Videos</Link>
//<Link to="/vidoesindari">VideosInDari</Link>
//<Link to="/playlist">PlayList</Link>

  { name: "home", href: "/" },
  { name: "courses", href: "/courses" },
  { name: "books", href: "/books" },
  { name: "videosindari", href: "/videosindari" },
  { name: "videos", href: "/videos" },
  { name: "playlist", href: "/playlist" },
];

  return (
    <nav className="bg-white dark:bg-gray-800 shadow-md fixed w-full z-10 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 py-3 flex justify-between items-center">

      <img  src={`https://www.mywebuniversity.com/images/TN_MyWebLogo1.jpg`} className="img-header" alt="MyWebUniversity Logo" />
      { /*  
        <Link to="/" className="text-xl font-bold text-green-700 dark:text-green-400">
          MyWebUniversity.com
        </Link>
        */ }

        <div className="hidden md:flex space-x-6 items-center">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.href}
              className="text-gray-700 dark:text-white hover:text-green-700 font-medium"
            >
              {link.name}
            </Link>
          ))}
          <button onClick={() => setDarkMode(!darkMode)} className="ml-4">
            {darkMode ? <Sun size={22} /> : <Moon size={22} />}
          </button>
        </div>
        <div className="md:hidden flex items-center gap-4">
          <button onClick={() => setDarkMode(!darkMode)}>
            {darkMode ? <Sun size={22} /> : <Moon size={22} />}
          </button>
          <button onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>
      {isOpen && (
        <div className="md:hidden bg-white dark:bg-gray-800 px-4 py-2 space-y-2">
          {navLinks.map((link) => (
            <Link
              key={link.name}
              to={link.href}
              className="block text-gray-700 dark:text-white hover:text-green-700 font-medium"
              onClick={() => setIsOpen(false)}
            >
              {link.name}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
